// olap-client/src/components/chat/ChatList.jsx
import React, { useContext, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Context } from '../..';
import CreateChatModal from '../CreateChatModal';
import { formatChatDate } from '../../utils/dateUtils';
import { stripHtml } from '../../utils/stripHtml';  // ✅ ДОБАВЬТЕ ИМПОРТ


const ChatList = observer(() => {
  const { chat } = useContext(Context);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');

  const getCompanionName = (chatItem) => {
    if (chatItem.type === 'private') {
      if (chatItem.companion) {
        const name = chatItem.companion.name || '';
        const surname = chatItem.companion.surname || '';
        const fullName = `${name} ${surname}`.trim();
        if (fullName) return fullName;
        if (chatItem.companion.email) return chatItem.companion.email;
      }
      
      if (chatItem.ChatMembers) {
        const currentUserId = JSON.parse(localStorage.getItem('user') || '{}').id;
        const otherMember = chatItem.ChatMembers.find(m => m.userId !== currentUserId);
        if (otherMember && otherMember.user) {
          const name = otherMember.user.persons_info?.name || '';
          const surname = otherMember.user.persons_info?.surname || '';
          const fullName = `${name} ${surname}`.trim();
          if (fullName) return fullName;
          if (otherMember.user.email) return otherMember.user.email;
        }
      }
      
      return 'Собеседник';
    }
    return chatItem.name || 'Чат';
  };

  const filteredChats = chat.chats.filter(chatItem => {
    if (!searchQuery.trim()) return true;
    const name = getCompanionName(chatItem).toLowerCase();
    return name.includes(searchQuery.toLowerCase());
  });

  return (
    <div style={{
      width: '320px',
      borderRight: '1px solid #e4e4e5',
      display: 'flex',
      flexDirection: 'column',
      background: '#ffffff'
    }}>
      {/* Шапка с поиском */}
      <div style={{
        padding: '12px',
        borderBottom: '1px solid #e4e4e5',
        display: 'flex',
        gap: '8px',
        alignItems: 'center'
      }}>
        <input
          type="text"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          placeholder="🔍 Поиск"
          style={{
            flex: 1,
            padding: '8px 12px',
            borderRadius: '20px',
            border: '1px solid #e4e4e5',
            outline: 'none',
            fontSize: '14px'
          }}
        />
        <button
          onClick={() => setShowCreateModal(true)}
          style={{
            background: '#3390ec',
            color: 'white',
            border: 'none',
            borderRadius: '50%',
            width: '36px',
            height: '36px',
            cursor: 'pointer',
            fontSize: '20px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
          title="Создать чат"
        >
          ➕
        </button>
      </div>

      {/* Список чатов */}
      <div style={{ flex: 1, overflowY: 'auto' }}>
        {chat.isLoading ? (
          <div style={{ textAlign: 'center', color: '#999', marginTop: '50px' }}>
            Загрузка...
          </div>
        ) : filteredChats.length === 0 ? (
          <div style={{ textAlign: 'center', color: '#999', marginTop: '50px', padding: '20px' }}>
            {searchQuery ? 'Ничего не найдено' : 'Нет чатов'}
          </div>
        ) : (
          filteredChats.map(chatItem => (
            <div
              key={chatItem.id}
              onClick={() => {
                chat.openChat(chatItem);
                chat.setView('chat');
              }}
              style={{
                padding: '12px',
                borderBottom: '1px solid #f0f0f0',
                cursor: 'pointer',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                background: chat.activeChat?.id === chatItem.id ? '#3390ec' : 'white',
                color: chat.activeChat?.id === chatItem.id ? 'white' : 'black',
                transition: 'background 0.2s'
              }}
              onMouseEnter={(e) => {
                if (chat.activeChat?.id !== chatItem.id) {
                  e.currentTarget.style.background = '#f4f4f5';
                }
              }}
              onMouseLeave={(e) => {
                if (chat.activeChat?.id !== chatItem.id) {
                  e.currentTarget.style.background = 'white';
                }
              }}
            >
              <div style={{ flex: 1, overflow: 'hidden' }}>
                <div style={{ 
                  fontWeight: 'bold', 
                  display: 'flex', 
                  alignItems: 'center',
                  gap: '5px'
                }}>
                  {chatItem.isPinned && <span title="Закреплен">📌</span>}
                  {getCompanionName(chatItem)}
                </div>
                {chatItem.lastMessage && (
                  <div style={{ 
                    fontSize: '13px', 
                    color: chat.activeChat?.id === chatItem.id ? 'rgba(255,255,255,0.8)' : '#707579',
                    marginTop: '4px',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis'
                  }}>
                    {/* === ИСПРАВЛЕНО: используем stripHtml === */}
                    {chatItem.lastMessage.sender?.persons_info?.name || 
                     chatItem.lastMessage.sender?.email || 'Вы'}: {stripHtml(chatItem.lastMessage.text)}
                  </div>
                )}
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '4px' }}>
                {chatItem.lastMessage && (
                    <div style={{ 
                        fontSize: '11px', 
                        color: chat.activeChat?.id === chatItem.id ? 'rgba(255,255,255,0.7)' : '#999'
                    }}>
                        {formatChatDate(chatItem.lastMessage.createdAt)}
                    </div>
                    )}
                {chatItem.unreadCount > 0 && (
                  <span style={{
                    background: chat.activeChat?.id === chatItem.id ? 'white' : '#3390ec',
                    color: chat.activeChat?.id === chatItem.id ? '#3390ec' : 'white',
                    borderRadius: '50%',
                    minWidth: '22px',
                    height: '22px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '12px',
                    fontWeight: 'bold'
                  }}>
                    {chatItem.unreadCount}
                  </span>
                )}
              </div>
            </div>
          ))
        )}
      </div>

      {showCreateModal && (
        <CreateChatModal onClose={() => setShowCreateModal(false)} />
      )}
    </div>
  );
});

export default ChatList;